module.exports = __webpack_public_path__ + "static/img/14.72a712b8.jpeg";